"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceCardComponent = void 0;
var react_1 = __importStar(require("react"));
var bg_png_1 = __importDefault(require("../../../../assets/choice_card/bg.png"));
var card_png_1 = __importDefault(require("../../../../assets/choice_card/card.png"));
var doshx_controls_web_1 = require("doshx_controls_web");
var react_router_dom_1 = require("react-router-dom");
var ChoiceCardComponent = function (props) {
    var navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "grid grid-cols-1 lg:grid-cols-2 relative h-[800px]  md:h-[400px]  rounded-xl" },
        react_1.default.createElement("div", { className: "lg:px-0  relative rounded-xl h-[400px]" },
            react_1.default.createElement("img", { className: "h-full object-cover rounded-t-lg md:rounded-l-lg", src: card_png_1.default })),
        react_1.default.createElement("div", { className: "flex flex-col items-center px-0 h-[400px]" },
            react_1.default.createElement("img", { className: "h-full object-cover absolute -z-20 rounded-r-lg", src: bg_png_1.default }),
            react_1.default.createElement("div", { className: "flex flex-col items-end gap-4 p-10 " },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "text-right", label: "Rewards Program", size: "6xlarge", textColor: "text-primary", bold: true }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "text-right", label: "A gift to you from us!", size: "2xlarge", textColor: "text-grey-300" }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "text-right", label: "Not only do you get instant rewards for being a loyal customer, but also \u2026", size: "small", textColor: "text-grey-300", bold: true }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "text-right", label: "Earn triple rewards on our exclusive own-brands!", size: "xsmall", textColor: "text-grey-300" }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "text-right", label: "Stay informed of available Choice Card promotional offers and benefits.", size: "xsmall", textColor: "text-grey-300" }),
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Learn More", backgroundColor: "bg-primary", size: "xsmall", onClick: function () {
                        navigate("/choice-card");
                    } })))));
};
exports.ChoiceCardComponent = ChoiceCardComponent;
